import api from '../../plugins/api';

// Ð ÑÑÐ½Ð¾Ð¹ Ð¾ÑÐºÐ°Ð· ÐÐµÑÐµÐºÐµ â Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÑÐµÑ applicationContinue Ñ ÐÐÐ ÐºÐ»Ð¸ÐµÐ½ÑÐ°
const berekeManualReject = (sourceId) => {
  return api.post(`/api/bank/bereke/manualReject?sourceId=${encodeURIComponent(sourceId)}`);
};

export default berekeManualReject;
